export const obtenerValorDescuento = ({valor, porcentaje}) => {

    let val = (valor * porcentaje) / 100
    return val

}